import React from "react";
import { sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";
import { format, parseISO } from "date-fns";

import CouponTable from "../../../components/master/CouponTable";
import ComponentLoader from "../../../components/ui/pageLoader/ComponentLoader";

import { contractAddIcon, downloadIcon } from "../../../assetData/icons";
import { actionPerm } from "../../../components/authNavigation/AuthNavbar";
import { downloadLoader } from "../../../assetData/loaders";

const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank,
      rowB.columnFiltersMeta[columnId]?.itemRank,
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const MasterCouponTable = (props) => {
  const {
    tableData,
    buttonConfig,
    setIsAdd,
    setIsEdit,
    setIsDelete,
    setIsImport,
    setSelectedItemId,
    renderKey,
    isLoading,
    setGlobalFilters,
    loading,
    actionPermissions,
    setIsFilter,
    isFilter,
    isDownloadClicked,
  } = props;

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "sl",
        header: () => <span className="inline-block w-max pl-2">S. NO.</span>,
        cell: (info) => <span>{info.row.index + 1}.</span>,
      },

      {
        accessorFn: (row) => row.description,
        id: "description",
        cell: (info) => (
          <span className="flex w-[370px]">
            {" "}
            {capitalizeFirstLetter(info.getValue())}{" "}
          </span>
        ),
        header: () => <span className="pl-1">description</span>,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },

      {
        accessorKey: "coupon_code",
        header: () => (
          <span className="inline-block w-full pl-1">coupon code</span>
        ),
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "unit",
        header: () => <span className="pl-1">unit</span>,
        cell: (info) => <span> {capitalizeFirstLetter(info.getValue())} </span>,
      },

      {
        accessorKey: "coupon_type",
        header: () => <span className="pl-1">type</span>,
        cell: (info) => <span>{capitalizeFirstLetter(info.getValue())}</span>,
      },

      {
        accessorKey: "value",
        header: () => <span className="flex justify-end pr-1">value</span>,
        cell: (info) => (
          <span className="flex justify-end">{info.getValue()}</span>
        ),
      },

      {
        accessorKey: "eff_start_date",
        header: () => <span className="pl-1">start date</span>,
        cell: (info) => (
          <span className="whitespace-nowrap">
            {" "}
            {format(new Date(info.getValue()), "dd MMM yyyy")}{" "}
          </span>
        ),
      },

      {
        accessorKey: "eff_end_date",
        header: () => <span className="pl-1">end date</span>,
        cell: (info) => (
          <span className="whitespace-nowrap">
            {" "}
            {format(new Date(info.getValue()), "dd MMM yyyy")}{" "}
          </span>
        ),
      },

      // {
      //   accessorKey: "created_at",
      //   header: () => <span>Tran history</span>,
      //   cell: (info) => <span className="">Hist</span>,
      // },
      // {
      //   accessorKey: "created_at",
      //   header: () => <span>created on</span>,
      //   cell: (info) => (
      //     <span className="inline-block w-max">
      //       {new Date(info.getValue()).toLocaleString("en-US", {
      //         day: "2-digit",
      //         month: "short",
      //         year: "numeric",
      //         hour: "numeric",
      //         minute: "numeric",
      //         hour12: true,
      //       })}
      //     </span>
      //   ),
      // },

      // {
      //   accessorKey: "updated_at",
      //   header: () => <span>updated on</span>,
      //   cell: (info) => (
      //     <span className="inline-block w-max">
      //       {new Date(info.getValue()).toLocaleString("en-US", {
      //         day: "2-digit",
      //         month: "short",
      //         year: "numeric",
      //         hour: "numeric",
      //         minute: "numeric",
      //         hour12: true,
      //       })}
      //     </span>
      //   ),
      // },

      // {
      //   accessorKey: "updated_by",
      //   header: () => <span>updated by</span>,
      //   cell: (info) => <span> {info.getValue()} </span>,
      // },

      {
        accessorKey: "status",
        header: () => <span className="pl-1">status</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "id",
        header: () => <span className="flex justify-center"> ACTIONS </span>,
        cell: (info) => <span> </span>,
      },
    ],
    [],
  );
  const handleDownloadButtonClick = () => {
    buttonConfig.downloadHandler();
  };

  const actionConfig = [
    {
      id: 3,
      name: "Add Coupon",
      image: contractAddIcon,
      actionHandler: () => setIsAdd(true),
      disable: actionPerm(actionPermissions)?.add_perm,
    },

    {
      id: 4,
      name: "Download Data",
      image: isDownloadClicked ? downloadLoader : downloadIcon,
      actionHandler: isDownloadClicked
        ? () => {}
        : buttonConfig.downloadHandler,
      disable: actionPerm(actionPermissions)?.download_perm,
    },
  ];

  const action = actionPerm(actionPermissions);

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <CouponTable
      columns={columns}
      loading={loading}
      tableData={tableData}
      buttonConfig={buttonConfig}
      setIsEdit={setIsEdit}
      setIsDelete={setIsDelete}
      setSelectedItemId={setSelectedItemId}
      renderKey={renderKey}
      filterField
      actionConfig={actionConfig}
      isLoading={isLoading}
      setGlobalFilters={setGlobalFilters}
      handleDownloadButtonClick={handleDownloadButtonClick}
      actions={action}
      setIsFilter={setIsFilter}
      isFilter={isFilter}
    />
  );
};

export default MasterCouponTable;
